import { z } from "zod";

import { userSchema } from "../../user";

export const communityMembersSchema = z.object({
  results: z.array(userSchema),
  total: z.number(),
});

export type CommunityMembersSchema = z.TypeOf<typeof communityMembersSchema>;
